<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
    import { ValidationError } from "@common/types";

    @Component({
        props: {
            propF: { type: Object, required: true },
            propErrors: { type: Array, required: true },
        }
    })
    export default class TextMultilineSingleValue extends Vue
    {
        get f(): AlternativeEditorAttributeFieldReadModel { return this.$props.propF as AlternativeEditorAttributeFieldReadModel; }
        get errors(): ValidationError[] { return this.$props.propErrors as ValidationError[]; }

        get error() { return this.errors?.find(error => error.Context.startsWith(`AlternativeAttribute:${this.f.Id}`))?.Error; }
    }
</script>

<template>
    <div class="form-group">
        <label><span v-if="f.IsRequired" style="color: red;">*</span> {{f.Name}}</label>
        
        <textarea class="form-control" placeholder="Enter text..." :rows="f.Rows"                  
                  v-model.trim="f.Value" 
                  :required="f.IsRequired === true" 
                  :readonly="f.IsReadonly === true" 
                  :minlength="f.MinLength != null ? f.MinLength : null"
                  :maxlength="f.MaxLength != null ? f.MaxLength : null">
        </textarea>
        
        <div class="error">{{error}}</div>
        <small class="form-text text-muted" v-if="f.Description">{{f.Description}}</small>
    </div>
</template>